import { todayDateString } from "../../../../../../../lib/dates";

export default {
  relationships(spouse, isSpouse) {
        if (spouse && !isSpouse) {
      return {
        dependent: "Dependent",
      };
    } else {
      return {
        spouse: "Spouse",
        dependent: "Dependent",
      };
    }
  },

  genders: {
    M: "Male",
    F: "Female",
  },
    /**
     * The coverage label for a saved insurance (user.userHealthInsurances entry).
     * Matches insuranceType, then the one field that tells same-type choices apart:
     * onExchange (ICHRA marketplace / non-marketplace) or
     * premiumReimbursementTaxable (QSEHRA pre-tax / post-tax employer plan).
     */
    insuranceCoverageLabel(planType, insurance) {
        for (const [label, coverage] of Object.entries(this.insuranceCoverages(planType))) {
            if (coverage.insuranceType !== insurance?.insuranceType) continue
            if (coverage.onExchange !== undefined && coverage.onExchange !== Boolean(insurance?.onExchange)) continue
            if (
                coverage.insuranceType === "GROUP" &&
                coverage.premiumReimbursementTaxable !== Boolean(insurance?.premiumReimbursementTaxable)
            ) continue
            return label
        }
        return ""
    },
  insuranceCoverages(planType) {
    if (planType === "ICHRA") {
      return {
        "Individual Coverage - marketplace plan": {
          insuranceType: "INDIVIDUAL",
          includesMedical: true,
          onExchange: true,
          premiumReimbursementTaxable: false,
        },

        "Individual Coverage - non-marketplace plan": {
          insuranceType: "INDIVIDUAL",
          includesMedical: true,
          onExchange: false,
          premiumReimbursementTaxable: false,
        },

        Medicare: {
          insuranceType: "MEDICARE",
          premiumReimbursementTaxable: false,
        },
      };
    } else if (planType === "QSEHRA") {
      return {
        "Individual Coverage": {
          insuranceType: "INDIVIDUAL",
          includesMedical: true,
          premiumReimbursementTaxable: false,
        },

        Medicare: {
          insuranceType: "MEDICARE",
          premiumReimbursementTaxable: false,
        },

        "Employer sponsored plan paid with pre-tax money (through a cafeteria plan)":
          {
            insuranceType: "GROUP",
            includesMedical: true,
            premiumReimbursementTaxable: true,
          },

        "Employer sponsored plan paid with post-tax money": {
          insuranceType: "GROUP",
          includesMedical: true,
          premiumReimbursementTaxable: false,
        },

        "Other Insurance (incl. other group coverage, COBRA, VA, Tricare, etc.)":
          {
            insuranceType: "OTHER",
            premiumReimbursementTaxable: false,
          },
      };
    } else {
      return {};
    }
  },

  /**
   * Which coverage choices a participant sees, from their current plans
   * (end date today or later), not the plan the flow was opened for:
   *   only ICHRAs  -> "ICHRA" (individual coverage and Medicare)
   *   any QSEHRA   -> "QSEHRA" (QSEHRA's fuller list), even with an ICHRA too
   *   no plans     -> "QSEHRA", the broader list
   * Pass the result to insuranceCoverages / insuranceCoverageLabel.
   */
  coveragePlanType(user) {
    const today = todayDateString();
    const currentTypes = (user?.userPlans || [])
      .filter((userPlan) => userPlan.endDate && userPlan.endDate >= today)
      .map((userPlan) => userPlan.type);
    const onlyIchra =
      currentTypes.length > 0 &&
      !currentTypes.includes("QSEHRA") &&
      currentTypes.includes("ICHRA");
    const planType = onlyIchra ? "ICHRA" : "QSEHRA";
    return planType;
  },

  coverageDates(startDate, startDates) {
        if (typeof startDate === "object") startDate = startDate?.display;

    const index = startDates?.findIndex(({ display }) => display === startDate);
    if (index >= 0) startDates = startDates?.slice(index);

    return startDates;
  },
};
